<script>
export default {
  name: 'RuleFormGroup',
  props: {
    value: { default: null },
    rules: { type: Array, default: () => [] },
    label: { type: String, default: null },
    description: { type: String, default: null },
    type: { type: String, default: 'text' },
    optional: { type: Boolean, default: false },
  },
  computed: {
    is_empty() {
      return this.value === null || this.value === ''
    },
    violation() {
      return this.rules.find(rule => !rule.satisfied)
    },
    // Anzeige: null = neutral, true/false = Bootstrap-Zustand
    state() {
      if (this.is_empty) return null
      return !this.violation
    },
    // Für den Parent: darf das Formular abgeschickt werden?
    valid() {
      if (this.is_empty) return this.optional
      return !this.violation
    },
    error() {
      return this.violation ? this.violation.message() : null
    },
  },
  watch: {
    valid: {
      immediate: true,
      handler(v) { this.$emit('validity-change', v) },
    },
  },
}
</script>

<template>
  <b-form-group :label="label" :description="description">
    <template v-if="$scopedSlots.description" #description>
      <slot name="description" />
    </template>
    <slot :state="state">
      <b-input :value="value" :type="type" :state="state"
               @input="$emit('input', $event)" />
    </slot>
    <b-form-invalid-feedback :state="state">{{ error }}</b-form-invalid-feedback>
  </b-form-group>
</template>
